var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLocalio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.228 3.654.066.055 6.075 5.973.058.07c.051.072.08.155.089.24v.12a.498.498 0 0 1-.089.24l-.058.069-6.075 5.973a.5.5 0 0 1-.843-.27l-.007-.086L16.443 13H6.95a.5.5 0 0 1-.492-.41l-.008-.09v-2.242l-4.875 4.794 4.875 4.793v-2.242l.008-.09a.5.5 0 0 1 .402-.402l.09-.008h7.068l.09.008a.5.5 0 0 1 .402.403l.008.09-.008.09a.5.5 0 0 1-.402.401l-.09.008H7.45v2.935l-.007.086a.501.501 0 0 1-.778.326l-.066-.056-6.074-5.973-.058-.069a.498.498 0 0 1-.09-.24v-.12a.498.498 0 0 1 .09-.24l.058-.07L6.6 8.71a.5.5 0 0 1 .844.27l.007.087V12h9.476a.5.5 0 0 1 .492.41l.006.055a.497.497 0 0 1 .012.049l.008.09v2.241l4.874-4.793-4.874-4.794V7.5l-.008.09a.5.5 0 0 1-.402.402l-.09.008H9.876l-.09-.008a.5.5 0 0 1-.402-.402l-.008-.09.008-.09a.5.5 0 0 1 .402-.402L9.876 7l6.568-.001V4.066l.007-.086a.501.501 0 0 1 .777-.326z",
    fill: "#000",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocalio);
export default __webpack_public_path__ + "static/media/ic-localio.f725efe35c837143001d74fb1fbce90b.svg";
export { ForwardRef as ReactComponent };